import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type AccessoriesSectionClasses = 'indicativeNumber';

const accessoriesSectionStyles = makeStyles<ISpcTheme, AccessoriesSectionClasses>(
  () => ({
    indicativeNumber: {
      width: 'fit-content',
      top: '-10px',
    },
  }),
  { name: 'Customise_AccessoriesSection' },
);

export default accessoriesSectionStyles;
